<div class="full-size">
	<div class="poster" *ngIf="mediaData.poster != ''">
		<img [src]="getPosterUrl()" class="full-size" [style]="'object-fit: ' + mediaData.posterFit" />
		<mat-icon class="center-button" (click)="player.play();" *ngIf="player.paused">play_arrow</mat-icon>
		<mat-icon class="center-button" (click)="player.pause();" *ngIf="!player.paused">pause</mat-icon>
	</div>

	<audio #player controls preload="auto" crossorigin="anonymous" class="player" controlsList="nodownload" (contextmenu)="onContextMenu($event);" (timeupdate)="onTimeUpdate(player);">
		<source [src]="this.mediaData.path + '.mp3'" type="audio/mpeg" />
	</audio>
</div>
